module.exports = __webpack_public_path__ + "img/magnum-chef.eb74da36.svg";